import React from 'react';
import { useDataLayerValue } from '../../DataLayer';
import './PlayListTable.scss';
import Table from './Table/Table';

function PlayListTable(props) {
    const listSong = props.listSong;
    const playListIdNow = props.playListIdNow;
    const [{ lang }] = useDataLayerValue();
    return (
        <div className="playlist-table">
            <div className="playlist-table-bg" style={{ backgroundColor: `${props.backgroundColor ? props.backgroundColor : ''}` }}></div>
            <div className="playlist-table-data">
                <h2 className="playlist-table-data-title">{lang == 'en' ? 'Play list' : 'Danh sách'}</h2>
                <Table listData={listSong} playListIdNow={playListIdNow} />
            </div>
        </div>
    );
}

export default PlayListTable;